export enum MissionTab {
  DAILY = 'daily',
  GAME_WEEKLY = 'weekly',
  STREAKS = 'streaks',
}
